import React, { useState } from 'react';
import { login, register } from '../api/authClient';
import './AuthScreen.css';

// Simple SVG Icons
const UserIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>
);

const LockIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
  </svg>
);

function AuthScreen({ onAuthSuccess }) {
  const [isLoginMode, setIsLoginMode] = useState(true);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    if (username.length < 3) {
      setError('Kullanıcı adı en az 3 karakter olmalıdır.');
      setIsLoading(false);
      return;
    }
    
    if (password.length < 6) {
      setError('Şifre en az 6 karakter olmalıdır.');
      setIsLoading(false);
      return;
    }

    const authFunction = isLoginMode ? login : register;
    const { data, error: apiError } = await authFunction(username, password);

    if (apiError) {
      setError(apiError);
      setIsLoading(false);
      return;
    }

    if (isLoginMode && data?.access_token) {
      localStorage.setItem('token', data.access_token);
      localStorage.setItem('username', username);
      onAuthSuccess(username);
    } else if (!isLoginMode) {
      setIsLoginMode(true);
      setError('Kayıt başarılı! Şimdi giriş yapabilirsiniz.');
      setUsername('');
      setPassword('');
    }
    
    setIsLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-glass-panel">
        <div className="auth-header">
          <h2>VectorSearch UI</h2>
          <p>{isLoginMode ? 'Sisteme giriş yaparak arama yapmaya başlayın' : 'Sistemi kullanmak için yeni bir hesap oluşturun'}</p>
        </div>
        
        {error && (
          <div className={`auth-alert ${error.includes('başarılı') ? 'auth-alert-success' : 'auth-alert-error'}`}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="auth-form-group">
            <label className="auth-label" htmlFor="username">Kullanıcı Adı</label>
            <div className="auth-input-wrapper">
              <input
                className="auth-input"
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                disabled={isLoading}
                autoComplete="off"
              />
              <div className="auth-input-icon">
                <UserIcon />
              </div>
            </div>
          </div>
          
          <div className="auth-form-group">
            <label className="auth-label" htmlFor="password">Şifre</label>
            <div className="auth-input-wrapper">
              <input
                className="auth-input"
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={isLoading}
              />
              <div className="auth-input-icon">
                <LockIcon />
              </div>
            </div>
          </div>
          
          <button type="submit" className="auth-submit-btn" disabled={isLoading}>
            {isLoading ? 'Lütfen bekleyin...' : (isLoginMode ? 'Giriş Yap' : 'Kayıt Ol')}
          </button>
        </form>

        <div className="auth-footer">
          {isLoginMode ? 'Henüz hesabınız yok mu?' : 'Zaten bir hesabınız var mı?'}
          <button 
            type="button" 
            className="auth-switch-link"
            onClick={() => {
              setIsLoginMode(!isLoginMode);
              setError('');
              setUsername('');
              setPassword('');
            }}
          >
            {isLoginMode ? 'Kayıt Ol' : 'Giriş Yap'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AuthScreen;
